<template>
        <div class="text-center">
        <v-dialog :value="value" @input="$emit('input')" :persistent="persitante"
                  width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    {{titre}}
                </v-card-title>
                <v-card-text class="pt-2">
                    {{message}}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                           text
                           @click.native="$emit('input')">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    
</template>

<script>
    export default {
        props: ['value', 'titre', 'message', 'persitante'],
        data() {
            return {
                dialog: false,
            };
        },
    }

</script>

<style scoped>
</style>